import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Problem } from "@/components/site/Problem";
import { Features } from "@/components/site/Features";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Innovation } from "@/components/site/Innovation";
import { WhoItHelps } from "@/components/site/WhoItHelps";
import { Company } from "@/components/site/Company";
import { ComingSoon } from "@/components/site/ComingSoon";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App min-h-screen bg-white font-body text-slate-900">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Problem />
          <Features />
          <HowItWorks />
          <Innovation />
          <WhoItHelps />
          <Company />
          <ComingSoon />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
